<template>
  <transition name='modal'>
    <div v-if="show && (mobileFullscreen || width >= 768)" class="modal" @click="$emit('close')">

      <div @click.stop :class="`flex flex-col modal-content ${extraClasses}`">
        <div class="flex cursor-pointer close-div lg:p-4 p-2 justify-end" type="default">
          <img class="align-end" @click="$emit('close')" src="@/assets/icons/svg/Close_16x16.svg" alt="Close" width="18" />
        </div>
        <slot></slot>
      </div>

    </div>
  </transition>
  <ElDrawer v-if="show && !mobileFullscreen && width < 768" class="modal rounded-t-12xl" :model-value="show"
            :show-close="false"
            :with-header="true"
            :append-to-body="true"
            direction="btt" :size="drawerHeight" @close="$emit('close')">
    <template #header>
      <div class="flex items-center justify-center rounded-t-2xl" v-touch:swipe.bottom="() => $emit('close')"
           >
        <div class="bg-bw-grey w-16 h-2"/>
      </div>
    </template>
    <div>

      <slot></slot>
    </div>
  </ElDrawer>
</template>

<script setup lang="ts">
import {ElDrawer} from "element-plus";
import {onBeforeUnmount, onMounted, ref} from "vue";

defineProps({
  show: Boolean,
  classes: String,
  mobileFullscreen: {
    default: true,
    type: Boolean,
    required: false,
  },
  drawerHeight: {
    default: "80%",
    type: String,
    required: false,
  },
  extraClasses: {
    default: "",
    type: String,
    required: false,
  },
  mobileClose: {
    default: false,
    type: Boolean,
    required: false,
  },
});

defineEmits(["close"]);
const width = ref(window.innerWidth);

function resize() {
  width.value = window.innerWidth;
}

onMounted(() => {
  window.addEventListener("resize", resize);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", resize);
});
</script>

<style scoped>
.modal {
  z-index: 9999; /* Ensures modal is always on top */
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  background-color: white;
  /* padding: 1em; */
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  max-height: 100%;
  overflow-y: hidden;
}

/* Animate modal */
.modal-enter-active {
  animation: modal .3s ease-out;
}

.modal-leave-active {
  animation: modal .1s ease-in reverse;
}

@keyframes modal {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }

  to{
    opacity: 1;
    transform: translateY(0);
  }
}

@media screen and (max-width: 768px) {
  .modal-content {
    min-width: 100%;
    max-width: 100%;
    min-height: 100%;
    max-height: 100%;
    border-radius: unset;
  }
}
</style>
